import '@src/@core/scss/layouts/navbar/home-navbar.scss';
import { useHistory } from 'react-router-dom';
import { isUserLoggedIn } from '@src/auth/utils';
import appConfig from '@src/configs/appConfig';
import { LogIn, Briefcase, Gift } from 'react-feather';
import { Button, Navbar, NavLink } from 'reactstrap';
import UserDropdown from './UserDropdown';

const HomeNavbar = () => {
  const history = useHistory();

  const loginBtn = () => {
    return isUserLoggedIn() ? (
      <UserDropdown />
    ) : (
      <Button
        className="home-navbar-login-btn"
        outline
        onClick={() => history.push('/login')}
      >
        <span className="align-middle">Sign In</span>
        <LogIn size={14} className="align-middle ms-25" />
      </Button>
    );
  };

  const providersBtn = () => {
    return (
      <Button
        className="home-navbar-providers-btn"
        outline
        onClick={() => {
          window.location.href = `${appConfig.urls.CORPORATE_WEB_APP}/`;
        }}
      >
        <Briefcase size={16} className="align-middle me-50" />
        <span className="align-middle">For Business</span>
      </Button>
    );
  };

  const giftCardBtn = () => {
    return (
      <Button
        className="home-navbar-providers-btn"
        outline
        onClick={() => {
          history.push(`/gift-card`);
        }}
      >
        <Gift size={16} className="align-middle me-50" />
        <span className="align-middle">Gift Cards</span>
      </Button>
    );
  };

  return (
    <Navbar expand="lg" container={false} className="header-navbar pb-2">
      <div className="navbar-container d-flex content home-navbar">
        <div className="bookmark-wrapper d-flex align-items-center justify-content-end">
          <ul className="nav navbar-nav align-items-center ms-auto">
            <div className="d-block d-sm-none">
              <NavLink className="nav-link-style">{providersBtn()}</NavLink>
            </div>
            <div className="d-sm-block d-none">{providersBtn()}</div>
          </ul>
          <ul className="nav navbar-nav align-items-center ms-auto">
            <div className="d-block d-sm-none">
              <NavLink className="nav-link-style">{giftCardBtn()}</NavLink>
            </div>
            <div className="d-sm-block d-none">{giftCardBtn()}</div>
          </ul>
        </div>
        <ul className="navbar-nav align-items-center ms-auto">
          <div className="d-block d-sm-none">
            <div className="nav-link-style">{loginBtn()}</div>
          </div>
          <div className="d-sm-block d-none">{loginBtn()}</div>
        </ul>
      </div>
    </Navbar>
  );
};

export default HomeNavbar;
